import type { FormFieldConfig } from "./FormFieldConfig.types";

export type GetFormFieldDerivedConfig<
  TName extends string,
  TArgs extends unknown[] = [],
  TFieldConfig extends FormFieldConfig<TName> = FormFieldConfig<TName>,
> = (...args: TArgs) => TFieldConfig;

export type GetGetFormFieldDefaultValue<TValue, TArgs extends unknown[] = []> = (...args: TArgs) => TValue;

export type FormFieldFactory<
  TName extends string,
  TFieldValue,
  TGetDerivedConfigArgs extends unknown[] = [],
  TGetDefaultValueArgs extends unknown[] = [],
  TFieldConfig extends FormFieldConfig<TName> = FormFieldConfig<TName>,
> = {
  getDerivedConfig: GetFormFieldDerivedConfig<TName, TGetDerivedConfigArgs, TFieldConfig>;
  getDefaultValue: GetGetFormFieldDefaultValue<TFieldValue, TGetDefaultValueArgs>;
};
